import { Column, Entity, JoinColumn, ManyToOne, OneToMany } from "typeorm";
import { CommonColumns } from "./common-columns.entity";
import { Question } from "./question.entity";
import { QuestionHeader } from "./question-header.entity";
import { Shop } from "./shop.entity";

@Entity()
export class QuestionPage extends CommonColumns {

  @Column()
  title: string;

  @Column({ name: 'disp_order', })
  dispOrder: number;

  @ManyToOne(() => QuestionHeader, questionHeader => questionHeader.questionPages, { nullable: false, })
  @JoinColumn({ name: 'question_header_id', referencedColumnName: 'id', })
  questionHeader: QuestionHeader;

  @OneToMany(() => Question, question => question.questionPage)
  questions: Question[];

  constructor(props: TQuestionPage) {
    super();
    Object.assign(this, props);
  }
}

export declare type TQuestionPage = Omit<QuestionPage, 'dummy-no-such-field'>;
export interface IQuestionPage extends TQuestionPage {};
